import { useStaticQuery, graphql } from "gatsby";
import { React, useCallback, useContext, useState } from "react";

import MunicipalityProvider from "./MunicipalityProvider";

export default function RootElementWrapper({ children }) {
  return <MunicipalityProvider>{children}</MunicipalityProvider>;
}
